import gql from 'graphql-tag'
import { PARTNERS_FRAGMENT } from './partnersFragment'

export const WHERE_TO_BUY = gql`
  query whereToBuy(
    $where: SectionWhereInput
    $order: SectionOrderByInput
    $partnersWhere: ElementWhereInput
    $settingsPlusWhere: SettingPlusWhereInput
    $first: Int
    $partnersFirst: Int
  ) {
    wtb: sections(where: $where, order: $order, first: $first) {
      nodes {
        name
        id
        propertyValues {
          id
          value
          property {
            id
            code
          }
        }

        elements(where: { active: { equals: true } }, orderBy: { sort: asc }) {
          name
          code
          id
          propertyValues {
            id
            value
            property {
              id
              name
              code
            }
          }
        }
      }
    }
    partners: elements(
      where: $partnersWhere
      first: $partnersFirst
      order: { sort: asc }
    ) {
      edges {
        node {
          ...partnersFragment
        }
      }
    }
    plus: settingPluses(where: $settingsPlusWhere) {
      id
      code
      value
      values
    }
  }
  ${PARTNERS_FRAGMENT}
`
